import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import lodash from "lodash";
import * as client from "openid-client";

import { getKeycloakConfig } from "@onesolution/services";
import { cache, cleanSessions, getUserSessionBypass } from "@onesolution/utils";
import unlinkKryssSso from "@onesolution/utils/userSync/unlinkKryssSso";

export const logout = createServerFn().handler(async () => {
	const config = await getKeycloakConfig();
	const userSession = await getUserSessionBypass();

	if (
		lodash.isNil(userSession) ||
		lodash.isEmpty(userSession) ||
		lodash.isNil(userSession?.id_token) ||
		lodash.isEmpty(userSession?.id_token)
	) {
		cache.clear();
		await cleanSessions();
		throw redirect({ to: "/login", replace: true });
	}

	let endSessionUrl: URL;

	try {
		await unlinkKryssSso();
		endSessionUrl = client.buildEndSessionUrl(config, {
			post_logout_redirect_uri: `${import.meta.env.VITE_FRONTEND_URL}/logout`,
			id_token_hint: userSession?.id_token || "",
		});
	} catch (error) {
		console.error("Error building end session URL:", error);
		cache.clear();
		throw redirect({ to: "/login", replace: true });
	}

	if (lodash.isNil(endSessionUrl)) {
		cache.clear();
		await cleanSessions();
		throw redirect({ to: "/login", replace: true });
	}

	cache.clear();
	throw redirect({ href: endSessionUrl.href });
});
